module.exports = __webpack_public_path__ + "64bc61c52da43955defb24a357bb679f.pdf";